import React, { useState, useEffect } from "react";
import { Frame, ScalingContainer } from "../../../AppStyled";

import { ReactComponent as MinusSVG } from "../../../assets/minus.svg";
import { ReactComponent as PlusSVG } from "../../../assets/plus.svg";
import { SetBetBox, Text, Ops, Opr, SetBetBtn, BackBtn } from "./SetBetStyled";

import useSound from "use-sound";
import confirmSfx from "../../../audio/confirm.mp3";
import closeSfx from "../../../audio/close.mp3";

import useBetOperations from "./useBetOperations";
export default function SetBet({
  bet,
  handleAbove,
  handleBetAmount,
  unBlur,
  handleNotification,
  toFix,
  currency,
  minBet,
  maxBet,
  h,
  scrollable,
  userSettings,
  prec
}) {
  const [value, setvalue] = useState(bet);
  const [inputValue, setinputValue] = useState(value);
  // const handleNotification = useCallback(() => {}, []);
  const { sound, volume } = userSettings;
  const [confirm] = useSound(confirmSfx, { volume });
  const [close] = useSound(closeSfx, { volume });
  const [clicked, setclicked] = useState(false);
  const [
    useBet,
    plus,
    minus,
    multiply,
    divide,
    handleButtonPress,
    handleButtonRelease,
  ] = useBetOperations(
    value,
    false,
    sound,
    handleNotification,
    toFix,
    minBet,
    maxBet,
    currency
    // sound === "1"
  );
  useEffect(() => {
    setvalue(useBet);
    setinputValue(useBet);
  }, [useBet]);

  const handleChange = (e) => {
    // const reg = /^-?\d+\.?\d*$/;
    const reg = /^\d*\.?\d*$/;
    // const q = e.target.value;

    // if (reg.test(q) || q === "") {
    //   setinputValue(q);
    // }
    const value = e.target.value;
    if (reg.test(value) || value === "") {
      let modifiedValue = value.replace(/,/g, ".");
  
      const [integerPart, decimalPart] = modifiedValue.split(".");
  
      if (prec >= 0) {
        if (decimalPart) {
          modifiedValue = `${integerPart}.${decimalPart.slice(0, prec)}`;
        }
      }
      setinputValue(modifiedValue);
    }
  };

  const handleBlur = (e) => {
    const n = e.target.value;
    const min = minBet.toFixed(toFix);
    const max = maxBet
    if (+n < +min || n === "" || n === ".") {
      setinputValue(min);
      setvalue(min);
      handleNotification(`Minimum bet limit is ${min} ${currency}`);
    } else if (+n >= +max) {
      const maxFixed = max.toFixed(toFix)
      setinputValue(maxFixed);
      setvalue(maxFixed);
      handleNotification(`Maximum bet limit is ${maxFixed} ${currency}`);
    } else {
      setinputValue(n);
      setvalue(n);
    }
  };
  const notifyText = false;

  const [playPress, setplayPress] = useState(false);
  const [playUnpress, setplayUnpress] = useState(false);
  const [plusPress, setPlusPress] = useState(false);
  const [minusPress, setMinusPress] = useState(false);

  const [halfAnim, sethalfAnim] = useState(false);
  const [multAnim, setmultAnim] = useState(false);
  const [multAnim5, setmultAnim5] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setplayPress(false);
      setplayUnpress(false);
    }, 200);
  }, [playPress]);

  return (
    <Frame
      className="Frame"
      unBlur={unBlur}
      opacity="true"
      scrollable={scrollable}
    >
      <ScalingContainer className="ScalingContainer" h={h}>
        <SetBetBox>
          <Text>
            <p>{currency}</p>
            <input
              type="text"
              maxLength="100"
              value={inputValue}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </Text>
          <Ops>
            <Opr
              onClick={() => {
                sethalfAnim(true);
                setTimeout(() => {
                  sethalfAnim(false);
                  divide();
                }, 300);
              }}
              anim={halfAnim}
            >
              <div className="white" />
              1/2
            </Opr>
            <Opr
              onClick={() => {
                setmultAnim(true);
                setTimeout(() => {
                  setmultAnim(false);
                  multiply(2);
                }, 300);
              }}
              anim={multAnim}
            >
              <div className="white" />
              2X
            </Opr>
            <Opr
              onClick={() => {
                setmultAnim5(true);
                setTimeout(() => {
                  setmultAnim5(false);
                  multiply(5);
                }, 300);
              }}
              anim={multAnim5}
            >
              <div className="white" />
              5X
            </Opr>
            <Opr
              onClick={minus}
              minusPress={minusPress}
              onTouchStart={() => {
                !notifyText && setMinusPress(true);
                handleButtonPress("acceleratableMinus");
              }}
              onTouchEnd={() => {
                setMinusPress(false);
                handleButtonRelease();
              }}
              onMouseDown={() => {
                !notifyText && setMinusPress(true);
                handleButtonPress("acceleratableMinus");
              }}
              onMouseUp={() => {
                setMinusPress(false);
                handleButtonRelease();
              }}
              onMouseLeave={() => {
                setMinusPress(false);
                handleButtonRelease();
              }}
            >
              <div className="white" />

              <MinusSVG />
            </Opr>
            <Opr
              onClick={plus}
              plusPress={plusPress}
              onTouchStart={() => {
                !notifyText && setPlusPress(true);
                handleButtonPress("acceleratablePlus");
              }}
              onTouchEnd={() => {
                setPlusPress(false);
                handleButtonRelease();
              }}
              onMouseDown={() => {
                !notifyText && setPlusPress(true);
                handleButtonPress("acceleratablePlus");
              }}
              onMouseUp={() => {
                setPlusPress(false);
                handleButtonRelease();
              }}
              onMouseLeave={() => {
                setPlusPress(false);
                handleButtonRelease();
              }}
            >
              <div className="white" />
              <PlusSVG />
            </Opr>
          </Ops>
          <SetBetBtn
            playPress={playPress}
            playUnpress={playUnpress}
            onClick={() => {
              if (!clicked) {
                setclicked(true);
                if (sound) confirm();
                setplayPress(true);
                setTimeout(() => {
                  setplayUnpress(true);
                }, 100);
                setTimeout(() => {
                  setclicked(false);
                  setplayPress(false);
                  handleBetAmount(useBet);
                  handleAbove(false);
                  handleAbove(false);
                }, 200);
              }
            }}
          >
            <div className="white" />
            SET
          </SetBetBtn>
          <BackBtn
            onClick={() => {
              if (!clicked) {
                setclicked(true);
                setTimeout(() => {
                  setclicked(false);
                }, 200);
                if (sound) close();
                handleAbove(false);
              }
            }}
          >
            BACK
          </BackBtn>
        </SetBetBox>
      </ScalingContainer>
    </Frame>
  );
}
